// @flow

import * as React from 'react';

import type { NavigationState } from '../context/Navigation';

function useNavigationState(): Array<
  (() => void) | { open: boolean, toggleOpen: () => mixed },
> {
  const [state, setState] = React.useState<NavigationState>(() => ({
    open: false,
    toggleOpen,
  }));

  function toggleOpen() {
    setState(prevState => ({
      ...prevState,
      open: !prevState.open,
    }));
  }

  return [state, toggleOpen];
}

export { useNavigationState };
